import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Write = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="write icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9931 5.54673L23.4267 4.11314C24.197 3.34279 24.1968 2.09359 23.4262 1.32296L22.6813 0.578127C21.9107 -0.192504 20.6615 -0.192739 19.8912 0.577604L18.4576 2.0112L21.9931 5.54673ZM1.5 6.98198C1.5 3.94441 3.96243 1.48198 7 1.48198H11.5C12.3284 1.48198 13 2.15355 13 2.98198C13 3.8104 12.3284 4.48198 11.5 4.48198H7C5.61929 4.48198 4.5 5.60126 4.5 6.98198V16.982C4.5 18.3627 5.61929 19.482 7 19.482H17C18.3807 19.482 19.5 18.3627 19.5 16.982V12.5C19.5 11.6716 20.1716 11 21 11C21.8284 11 22.5 11.6716 22.5 12.5V16.982C22.5 20.0195 20.0376 22.482 17 22.482H7C3.96243 22.482 1.5 20.0195 1.5 16.982V6.98198ZM9.32457 11.4185L8.5469 14.493C8.4471 15.2036 8.79141 15.5664 9.52404 15.4702C9.90157 15.3755 12.5975 14.6914 12.5975 14.6914C12.8117 14.6417 13.0033 14.5365 13.1543 14.3855L20.5671 6.94918L17.0433 3.42539L9.63046 10.8617C9.47953 11.0127 9.37425 11.2043 9.32457 11.4185Z"
    />
  </svg>
)
